"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_BYTES = '0x';
exports.NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
//# sourceMappingURL=constants.js.map